export class SDLine {
    lineName: string;
    lineType: string;
    stockNumber: string;
    taxon: string;
    isSelected?: boolean;
}
